import { authConfigAxios } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';

export const signUp = async formData => {
    const api = authConfigAxios();
    const { data, error } = await api.post(ENDPOINTS.SIGNUP, formData).catch(error => {
        if (error.request.status == 400) {
            return { error: 'Impossível fazer o cadastro com as credenciais fornecidas.' };
        } else {
            return { error: 'Aconteceu um erro interno.' };
        }
    });
    if (data) {
        // await successHandlerLogin(data);
        return { data };
    } else {
        return { error };
    }
};
export const authorizationLogin = async payload => {
    const api = authConfigAxios();
    const { data, error } = await api.post(ENDPOINTS.LOGIN, payload).catch(error => {
        // debugger;
        // console.log(error)
        if (error.request.status == 400) {
            return { error: 'Impossível fazer login com as credenciais fornecidas.' };
        } else {
            return { error: 'Aconteceu um erro interno.' };
        }
    });
    if (data) {
        return { data };
    } else {
        return { error };
    }
};
export const sendUpdatePasswordRequest = async payload => {
    const api = authConfigAxios();
    const { data } = await api.post(ENDPOINTS.CHANGE_PASSWORD, payload);
    return data;
};
